import { useGetPropertiesQuery as useGetPropertiesTokkoQuery } from '@apis/middlewareTokkoApi/properties'
import { useGetNewPropertiesQuery as useGetPropertiesMiddlewareTokkoQuery } from '@apis/mediacore/owner'
import { useGetPropertiesQuery as useGetPropertiesMediacoreQuery } from '@apis/mediacore/properties'
import {
  makeFormDataByFilters,
  makeParamsByFiltersMediacore,
  makeParamsGetByFilters,
  makeFormDataV2ByFilters,
} from '@helpers/helper.filters'
import { FiltersProperties } from 'types'

type Props = {
  filters: FiltersProperties
  coordinates?: any
  polygonCoordinates?: any
  offset?: number
  orders?: { order: string; order_by: string }
  tokkoKey?: string
  custom_tags?: number[]
}

function useQueryProperties({
  filters,
  coordinates = [],
  polygonCoordinates = [],
  orders = { order: '', order_by: '' },
  offset = 0,
  tokkoKey,
  custom_tags
}: Props) {
  const middlewarev2: boolean = process.env.GATSBY_USE_MIDDLEWARE_V2?.toLowerCase() === 'true'

  const params_get = tokkoKey
    ? middlewarev2
      ? makeParamsGetByFilters(orders, offset, polygonCoordinates)
      : makeParamsGetByFilters(orders, offset, polygonCoordinates) +
        makeFormDataByFilters(filters, coordinates, polygonCoordinates)
    : makeParamsByFiltersMediacore(filters, polygonCoordinates, coordinates)

  const params_post = makeFormDataV2ByFilters(filters, coordinates, polygonCoordinates, orders)

  const {
    data,
    data: properties,
    isLoading,
    isError,
    isFetching,
  } = tokkoKey //EDIT
    ? middlewarev2
      ? useGetPropertiesMiddlewareTokkoQuery({
          API_KEY: tokkoKey,
          params_get: params_get,
          params_post: params_post,
          coordinates,
          polygonCoordinates,
          CTAG: custom_tags,
        })
      : useGetPropertiesTokkoQuery({
          API_KEY: tokkoKey,
          params_get: params_get,
          coordinates,
          polygonCoordinates,
        })
    : useGetPropertiesMediacoreQuery({
        CLIENT_ID: process.env.GATSBY_CLIENTID,
        params_get: params_get,
      })

  return {
    data,
    properties,
    isLoading,
    isError,
    isFetching,
  }
}

export default useQueryProperties
